import axios from "@standard/axios";

export const trigger = () => {
  const promise = new Promise((resolve, reject) => {
    axios
      .get(`trigger`)
      .then((res) => resolve(res.data))
      .catch((errors) => reject(errors));
  });

  return promise;
};
